module.exports = __webpack_public_path__ + "static/development1-06275cea76caa68f86d05e5e0655ccca.svg";